





















































































import { computed, defineComponent, ref, set } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import useUserVerification from "@/hooks/useUserVerification";
import providers from "@/lib/api";
import config from "@/config";
import { ROLES } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import BaseStepper from "@/components/BaseStepper";
import PageTitle from "@/components/PageTitle";
import PayoutForm from "@/components/PayoutForm";
import SignUpComponent from "@/components/SignUpComponent";
import PayeeInfoButton from "./PayeeInfoButton.vue";
import PersonalIdForm from "./PersonalIdForm.vue";
import PersonalInfoForm from "./PersonalInfoForm.vue";
import PersonalLocalization from "./PersonalLocalization.vue";
import SafeForWorkSetup from "./SafeForWorkSetup.vue";

interface StepData {
  name: string;
  step: number;
  valid: boolean;
}

export default defineComponent({
  name: "PayeeInfoSetupView",
  components: {
    SignUpComponent,
    PayoutForm,
    PersonalIdForm,
    PersonalInfoForm,
    PayeeInfoButton,
    BaseButton,
    BaseIcon,
    PageTitle,
    BaseStepper,
    PersonalLocalization,
    SafeForWorkSetup,
  },
  setup(_, { emit, root }) {
    const { authUser, updateUser } = useAuthUser();
    const { start, findMyStatus } = useUserVerification();
    const submits = ref<Record<string, () => Promise<any>>>({});
    const loading = ref(false);
    const sendingData = ref(false);

    const safeMode = computed(() => !authUser.value);

    const stepsNames = [
      ...(!authUser.value ? ["join"] : []),
      "personalInfo",
      ...(!config.featureHideLocalization ? ["personalLocalization"] : []),
      ...(config.featureNSFW ? ["safeForWorkStatus"] : []),
      "sensitiveAgreement",
      // "payeeInfo",
    ];

    const steps = computed<StepData[]>(() =>
      stepsNames.map((i, index) => ({ name: i, valid: false, step: index + 1 }))
    );

    const currentStep = ref<StepData>(steps.value[0]);

    const getStepTemplateName = (step: number) => "step-" + step;

    const handleTitleClick = async () => {
      if (currentStep.value.step === 1) {
        root.$router.push({ name: "becomeCreator" });
      } else {
        currentStep.value = steps.value[currentStep.value.step - 2];
      }
    };

    const startUserVerification = async () => {
      try {
        if (!authUser.value) return;
        sendingData.value = true;
        await start(authUser.value.id);
        const promise = findMyStatus();
        emit("form:finishStep", promise);
        await promise;
        const { role, authorities } = await providers.UserProvider.getMyAuthorities();
        updateUser({ ...authUser.value, role }, authorities);
      } finally {
        sendingData.value = false;
      }
    };

    const handleButtonClick = async (hasNext: boolean, step: number) => {
      const stepInProcess = steps.value[step - 1];
      if (!stepInProcess) return;

      if (!safeMode.value) {
        try {
          sendingData.value = true;
          await submits.value[stepInProcess.name]?.();
        } catch (e) {
          /* eslint-disable no-console */
          console.error(e);
          return;
        } finally {
          sendingData.value = false;
        }
      }

      if (hasNext) {
        loading.value = false;
        currentStep.value = steps.value[currentStep.value.step];
      } else {
        if (safeMode.value) {
          for (const step of steps.value) {
            try {
              sendingData.value = true;
              await submits.value[step.name]?.();
            } catch (e) {
              /* eslint-disable no-console */
              console.error(e);
              currentStep.value = step;
              return;
            } finally {
              sendingData.value = false;
            }
          }
        }
        await startUserVerification();
      }
    };
    const setCb = (stepName: string, cb: Promise<any>) => {
      set(submits.value, stepName, cb);
    };

    return {
      loading,
      sendingData,
      steps,
      ROLES,
      safeMode,
      currentStep,
      getStepTemplateName,
      setCb,
      handleTitleClick,
      handleButtonClick,
    };
  },
});
